import { Form, Formik } from 'formik';
import { Fragment, memo, ReactElement, useEffect, useMemo, useState } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { PmiButton } from 'shell/components/shared/button';
import { noop } from 'shell/utils/noop';
import { PracticeDetailCrumbs, PracticeManagementCrumbs } from 'practice/constants/practice-crubs';
import { Grid, useEventCallback } from '@mui/material';
import Buttons from 'practice/components/detail/buttons';
import FormDetail from 'practice/components/detail/form';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse, HttpResponseList } from 'shell/models/http-response';
import { DataSubjectVerbalOfPraticeunavailabilty, PracticeData } from 'shell/models/practice';
import { __CIVIC_API_URL__, __PRACTICE_API_URL__ } from 'shell/constants/environment';
import { transformerPraticeDetail } from 'practice/utils/practice-detail-transform';
import { ForeignAddressVM, PracticeDetailVM } from 'practice/view-models/practice-detail';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { ModalViewerPDF } from 'shell/components/shared/pdf-modal';
import ButtonsIsUnAvailability from 'practice/components/pratice-unavailabilty/edit/buttons';
import FormDetailIsUnAvailability from 'practice/components/pratice-unavailabilty/edit/form';
import PrintSuccessModal from 'practice/components/pratice-unavailabilty/edit/print-success-modal';
import { Attachment } from 'shell/models/attachment';
import { AxiosResponse } from 'axios';
import { AttachmentTransofrmer } from 'practice/utils/attachment-transform';
import { PracticeSearchType, PracticeFilterSearchType } from '../storage-practice';
import { useFilterTable } from 'shell/hooks/use-filter-table';
import { blobToBase64 } from 'shell/utils/base64-to-blob';
import { TypeRegister } from 'practice/constants/type-register';
import { RequestCertificate } from 'shell/models/certification';
import { MilanMuncipality } from 'practice/constants/muncipality';
import { PraticeEditResidenceAddress } from 'practice/view-models/practice-edit-residence';
import PmiTitle from 'shell/components/shared/title';

interface PracticeDetailPageProps {
  isDetail?: boolean;
  isPraticeUnAvailability?: boolean;
}

const PracticeDetailPageComponent = ({
  isDetail,
  isPraticeUnAvailability,
}: PracticeDetailPageProps): ReactElement => {
  const navigate = useNavigate();

  const [pdfModal, setPdfModal] = useState<{
    data: string;
    open: boolean;
    name: string;
  }>({
    data: '',
    open: false,
    name: '',
  });

  const [listSubjectPraticeunavailabilty, setListSubjectPraticeunavailabilty] = useState<{
    allListSubjectArray: Array<DataSubjectVerbalOfPraticeunavailabilty>;
    currentListSubject: Array<DataSubjectVerbalOfPraticeunavailabilty>;
  }>({ allListSubjectArray: [], currentListSubject: [] });

  const [isSuccessModalOpen, setSuccessModal] = useState<boolean>(false);
  const params = useParams();

  const [queryParams] = useSearchParams();

  const [active, setActive] = useState<number | undefined>();

  const redirectUri = queryParams.get('redirectUri') || '';
  const redirectUriHistory = queryParams.get('redirectUriHistory') || '';

  const printVerbalOfPraticeunavailabiltyBE = useHttpClient<Blob>(
    `${__PRACTICE_API_URL__}/pratiche/stampa/accertata-irreperibilita`,
    {
      options: { method: 'POST' },
    }
  );

  const subjectVerbalOfPraticeunavailabilty = useHttpClient<
    HttpResponseList<Array<DataSubjectVerbalOfPraticeunavailabilty>>
  >(`${__PRACTICE_API_URL__}/pratiche/lista-interessati`, {
    options: { method: 'POST' },
  });

  const printDeclarationUnavailability = useHttpClient<Blob>(
    `${__PRACTICE_API_URL__}/pratiche/stampa/dichiarazione-dichiarante`,
    {
      options: { method: 'POST' },
    }
  );

  const getAttachmentComunicationProcedureStartFunc = useHttpClient<Blob>(
    `${__PRACTICE_API_URL__}/pratiche/stampa/comunicazione-avvio-procedimento`,
    {
      options: { method: 'POST' },
    }
  );

  const printComunicationToPersonFunc = useHttpClient<Blob>(
    `${__PRACTICE_API_URL__}/pratiche/stampa/comunicazione-a-interessato`,
    {
      options: { method: 'POST' },
    }
  );

  const printComunicationToPersonBOFunc = useHttpClient<Blob>(
    `${__PRACTICE_API_URL__}/pratiche/stampa/comunicazione-a-interessato-bo`,
    {
      options: { method: 'POST' },
    }
  );

  const printOtherSubjectPraticeunavailabilty = useEventCallback(() => {
    // chiudere modale stampa
    setPdfModal({ data: '', open: false, name: '' });

    if (listSubjectPraticeunavailabilty.currentListSubject.length === 0) {
      return;
    }

    const newArray = listSubjectPraticeunavailabilty.currentListSubject.slice();

    const currentSubject = newArray.shift();

    (
      printVerbalOfPraticeunavailabiltyBE({
        data: {
          praticaKeyVO: {
            codiceEnte: params.codiceEnte || undefined,
            idAnnoPratica: params.idAnnoPratica
              ? Number.parseInt(params.idAnnoPratica, 10)
              : undefined,
            progressivoPratica: params.progressivoPratica
              ? Number.parseInt(params.progressivoPratica, 10)
              : undefined,
            tipoRegistro: params.tipoRegistro || undefined,
          },
          interessato: currentSubject,
        },
        responseType: 'blob',
      }) as ResponsePromise<Blob>
    ).then((response) => {
      const pdfCertificate = response?.data;
      if (pdfCertificate) {
        const blob = new Blob([pdfCertificate], { type: 'application/pdf' });
        blobToBase64(blob).then((base64) => {
          setPdfModal({
            data: base64.split(',')[1],
            name: 'Riepilogo stampa',
            open: true,
          });
        });
      }

      setListSubjectPraticeunavailabilty({
        allListSubjectArray: listSubjectPraticeunavailabilty.allListSubjectArray,
        currentListSubject: newArray,
      });
    });
  });

  const printVerbalOfPraticeUnavailabilty = useEventCallback(() => {
    (
      subjectVerbalOfPraticeunavailabilty({
        data: {
          codiceEnte: params.codiceEnte || undefined,
          idAnnoPratica: params.idAnnoPratica
            ? Number.parseInt(params.idAnnoPratica, 10)
            : undefined,
          progressivoPratica: params.progressivoPratica
            ? Number.parseInt(params.progressivoPratica, 10)
            : undefined,
          tipoRegistro: params.tipoRegistro || undefined,
        },
      }) as ResponsePromise<HttpResponseList<Array<DataSubjectVerbalOfPraticeunavailabilty>>>
    ).then((response) => {
      const castedData = response?.data.payload
        .list as Array<DataSubjectVerbalOfPraticeunavailabilty>;

      setListSubjectPraticeunavailabilty({
        allListSubjectArray: castedData || [],
        currentListSubject: castedData || [],
      });

      printOtherSubjectPraticeunavailabilty();
    });
  });

  const printFolder = useHttpClient<Blob>(`${__PRACTICE_API_URL__}/pratiche/stampa/cartellina`, {
    options: { method: 'POST' },
  });

  const printFolderForPracticeTemporary = useHttpClient<Blob>(
    `${__PRACTICE_API_URL__}/pratiche/stampa/dichiarazione-anagrafe-temporanea`,
    {
      options: { method: 'POST' },
    }
  );

  const printReceipt = useHttpClient<Blob>(`${__PRACTICE_API_URL__}/pratiche/stampa/ricevuta`, {
    options: { method: 'POST' },
  });

  const printReceiptForPracticeTemporary = useHttpClient<Blob>(
    `${__PRACTICE_API_URL__}/pratiche/stampa/ricevuta-anagrafe-temporanea`,
    {
      options: { method: 'POST' },
    }
  );

  const printLetter = useHttpClient<Blob>(
    `${__PRACTICE_API_URL__}/pratiche/stampa/lettera-comune-anagrafe-temporanea`,
    {
      options: { method: 'POST' },
    }
  );

  const onPrintFolder = useEventCallback(() => {
    (
      printFolder({
        data: {
          codiceEnte: params.codiceEnte || undefined,
          tipoRegistro: params.tipoRegistro || undefined,
          idAnnoPratica: params.idAnnoPratica || undefined,
          progressivoPratica: params.progressivoPratica || undefined,
        },
        responseType: 'blob',
      }) as ResponsePromise<Blob>
    ).then((response) => {
      const pdfCertificate = response?.data;
      if (pdfCertificate) {
        const blob = new Blob([pdfCertificate], { type: 'application/pdf' });
        blobToBase64(blob).then((base64) => {
          setPdfModal({
            data: base64.split(',')[1],
            name: 'Riepilogo stampa',
            open: true,
          });
        });
      }
    });
  });

  const onPrintFolderForPracticeTemporary = useEventCallback(() => {
    (
      printFolderForPracticeTemporary({
        data: {
          richiestaDichiarazioneDichiaranteVO: {
            codiceEnte: params.codiceEnte || undefined,
            idAnnoPratica: params.idAnnoPratica
              ? Number.parseInt(params.idAnnoPratica, 10)
              : undefined,
            progressivoPratica: params.progressivoPratica
              ? Number.parseInt(params.progressivoPratica, 10)
              : undefined,
            tipoRegistro: params.tipoRegistro || undefined,
            dataRilascioDocumento:
              initialValues?.accountholder?.releaseDocumentDate?.toFormat('yyyy-MM-dd') ||
              initialValues?.applicant?.releaseDocumentDate?.toFormat('yyyy-MM-dd') ||
              undefined,
            luogoRilascioDocumento:
              initialValues?.accountholder?.locationDocument ||
              initialValues?.applicant?.locationDocument ||
              undefined,
            numeroDocumento:
              initialValues?.accountholder?.numberDocument ||
              initialValues?.applicant?.numberDocument ||
              undefined,
          },
        },
        responseType: 'blob',
      }) as ResponsePromise<Blob>
    ).then((response) => {
      const pdfCertificate = response?.data;
      if (pdfCertificate) {
        const blob = new Blob([pdfCertificate], { type: 'application/pdf' });
        blobToBase64(blob).then((base64) => {
          setPdfModal({
            data: base64.split(',')[1],
            name: 'Stampa Dichiarazione',
            open: true,
          });
        });
      }
    });
  });

  const onPrintReceipt = useEventCallback(() => {
    (
      printReceipt({
        data: {
          codiceEnte: params.codiceEnte || undefined,
          tipoRegistro: params.tipoRegistro || undefined,
          idAnnoPratica: params.idAnnoPratica || undefined,
          progressivoPratica: params.progressivoPratica || undefined,
        },
        responseType: 'blob',
      }) as ResponsePromise<Blob>
    ).then((response) => {
      const pdfCertificate = response?.data;
      if (pdfCertificate) {
        const blob = new Blob([pdfCertificate], { type: 'application/pdf' });
        blobToBase64(blob).then((base64) => {
          setPdfModal({
            data: base64.split(',')[1],
            name: 'Riepilogo stampa',
            open: true,
          });
        });
      }
    });
  });

  const onPrintLetter = useEventCallback(() => {
    (
      printLetter({
        data: {
          codiceEnte: params.codiceEnte || undefined,
          tipoRegistro: params.tipoRegistro || undefined,
          idAnnoPratica: params.idAnnoPratica
            ? Number.parseInt(params.idAnnoPratica, 10)
            : undefined,
          progressivoPratica: params.progressivoPratica
            ? Number.parseInt(params.progressivoPratica, 10)
            : undefined,
        },
        responseType: 'blob',
      }) as ResponsePromise<Blob>
    ).then((response) => {
      const pdfCertificate = response?.data;
      if (pdfCertificate) {
        const blob = new Blob([pdfCertificate], { type: 'application/pdf' });
        blobToBase64(blob).then((base64) => {
          setPdfModal({
            data: base64.split(',')[1],
            name: 'Stampa Lettera',
            open: true,
          });
        });
      }
    });
  });

  const onPrintReceiptForPracticeTemporary = useEventCallback(() => {
    (
      printReceiptForPracticeTemporary({
        data: {
          codiceEnte: params.codiceEnte || undefined,
          tipoRegistro: params.tipoRegistro || undefined,
          idAnnoPratica: params.idAnnoPratica
            ? Number.parseInt(params.idAnnoPratica, 10)
            : undefined,
          progressivoPratica: params.progressivoPratica
            ? Number.parseInt(params.progressivoPratica, 10)
            : undefined,
        },
        responseType: 'blob',
      }) as ResponsePromise<Blob>
    ).then((response) => {
      const pdfCertificate = response?.data;
      if (pdfCertificate) {
        const blob = new Blob([pdfCertificate], { type: 'application/pdf' });
        blobToBase64(blob).then((base64) => {
          setPdfModal({
            data: base64.split(',')[1],
            name: 'Stampa Ricevuta',
            open: true,
          });
        });
      }
    });
  });

  const [pratica, getPratica] = useHttpFetch<HttpResponse<PracticeData>, PracticeDetailVM>(
    `${__PRACTICE_API_URL__}/pratiche/pratica/${params.codiceEnte}/${params.idAnnoPratica}/${params.tipoRegistro}/${params.progressivoPratica}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
      transformer: transformerPraticeDetail,
    }
  );

  const [list] = useHttpFetch<HttpResponseList<RequestCertificate>, Array<RequestCertificate>>(
    `${__CIVIC_API_URL__}/messi-civici/atti/lista-pratica`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'POST',
        loading: true,
        data: {
          key: {
            codiceEnte: params.codiceEnte || undefined,
            tipoRegistro: params.tipoRegistro || undefined,
            idAnnoPratica: params.idAnnoPratica
              ? Number.parseInt(params.idAnnoPratica, 10)
              : undefined,
            progressivoPratica: params.progressivoPratica
              ? Number.parseInt(params.progressivoPratica, 10)
              : undefined,
          },
        },
      },
      transformer: (response: AxiosResponse<HttpResponseList<RequestCertificate>>) => {
        const { data } = response;
        return data?.payload?.list || [];
      },
    }
  );

  const [hasAttentionNote, setHasAttentionNote] = useState<boolean>(false);

  useEffect(() => {
    setHasAttentionNote((oldState) => {
      if (oldState) {
        return oldState;
      }

      return ((list.data as Array<RequestCertificate>) || []).length > 0;
    });
  }, [list.data]);

  const [viewMessi, setViewMessi] = useHttpFetch<
    HttpResponse<PracticeData>,
    HttpResponse<PracticeData>
  >(`${__PRACTICE_API_URL__}/accertamento-messi/abilitazione-bottoni-messi`, {
    onBootstrap: true,
    options: {
      errorCatching: true,
      method: 'POST',
      loading: true,
      data: {
        key: {
          codiceEnte: params.codiceEnte,
          idAnnoPratica: params.idAnnoPratica ? Number.parseInt(params.idAnnoPratica, 10) : '',
          tipoRegistro: params.tipoRegistro,
          progressivoPratica: params.progressivoPratica
            ? Number.parseInt(params.progressivoPratica, 10)
            : '',
        },
      },
    },
    transformer: (response: AxiosResponse<HttpResponse<PracticeData>>) => {
      return response.data;
    },
  });

  const [, getAttachmentDeclaration] = useHttpFetch<
    HttpResponse<Attachment>,
    AttachmentTransofrmer
  >(
    `${__PRACTICE_API_URL__}/allegati/${params.codiceEnte}-${params.idAnnoPratica}-${params.tipoRegistro}-${params.progressivoPratica}-3-c`,
    {
      onBootstrap: false,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
      transformer: (response: AxiosResponse<HttpResponse<Attachment>>) => {
        return {
          contenutoPdf: response?.data?.payload?.contenutoAllegato || '',
          name: response?.data?.payload?.nomeFile || '',
        };
      },
    }
  );

  const filterTable = useFilterTable<PracticeSearchType>();

  useEffect(() => {
    if (
      filterTable?.values?.searchType === PracticeFilterSearchType.SEARCH_BY_PRATICE ||
      filterTable?.values?.searchType === PracticeFilterSearchType.SEARCH_BY_PERSON
    ) {
      filterTable?.setValues({ ...filterTable?.values, isChildComponentVisited: true });
    }
  }, []);
  const getAttachmentDeclarationFunc = useEventCallback(() => {
    (
      getAttachmentDeclaration() as ResponsePromise<
        HttpResponse<Attachment>,
        HttpResponse<AttachmentTransofrmer>
      >
    ).then((response) => {
      const responseCasted = response as HttpResponse<AttachmentTransofrmer>;
      const pdfCertificate = responseCasted?.payload?.contenutoPdf;
      if (pdfCertificate) {
        setPdfModal({ data: pdfCertificate, name: 'Stampa Ricevuta', open: true });
      }
    });
  });

  const loadViewMessi = useEventCallback(() => {
    return new Promise<void>((resolve) => {
      (
        setViewMessi() as ResponsePromise<HttpResponse<PracticeData>, HttpResponse<PracticeData>>
      ).then(() => {
        resolve();
      });
    });
  });

  const loadUpdateDate = useEventCallback((): Promise<PracticeDetailVM> => {
    setActive(undefined);

    return (getPratica() as ResponsePromise<HttpResponse<PracticeData>, PracticeDetailVM>).then(
      (response) => {
        return response as PracticeDetailVM;
      }
    );
  });

  const handleExit = useEventCallback(() => {
    navigate('/pratiche/ricerca');
  });

  const isLoading = !pratica.data || pratica.isLoading || viewMessi.isLoading;

  const initialValues: PracticeDetailVM | null = useMemo(() => {
    if (!pratica.data) {
      return null;
    }

    const italianAddress = (pratica?.data as PracticeDetailVM)?.address?.italianAddress;

    const foreignAddress = (pratica?.data as PracticeDetailVM)?.address
      ?.foreignAddress as ForeignAddressVM;

    const isForeignAddressExists =
      foreignAddress?.cap &&
      foreignAddress?.civic &&
      foreignAddress?.consulate &&
      foreignAddress?.foreignMunicipality &&
      foreignAddress?.foreignProvince &&
      foreignAddress?.foreignMunicipalityId &&
      foreignAddress?.foreignState &&
      foreignAddress?.foreignStateId &&
      foreignAddress?.territory &&
      foreignAddress?.toponymDenomination;

    const editResidenceInitialValues = {
      residence: {
        checkedResidence:
          isForeignAddressExists ||
          (params.tipoRegistro === TypeRegister.Residence &&
            (pratica?.data as PracticeDetailVM)?.accountholder?.isAire)
            ? true
            : false, // estera
        italian: italianAddress
          ? {
              municipality: {
                // id:

                description: italianAddress?.municipality
                  ? italianAddress?.municipality
                  : params.tipoRegistro === TypeRegister.RegisterOfficeTemporary
                  ? MilanMuncipality.description
                  : '',
                province: italianAddress?.province
                  ? italianAddress?.province
                  : params.tipoRegistro === TypeRegister.RegisterOfficeTemporary
                  ? MilanMuncipality.province
                  : '',
                provinceCode: italianAddress?.province
                  ? italianAddress?.province
                  : params.tipoRegistro === TypeRegister.RegisterOfficeTemporary
                  ? MilanMuncipality.provinceCode
                  : '',
              },
              cap: italianAddress?.cap || '',
              address: italianAddress?.street
                ? {
                    code: Number(italianAddress?.codVia),
                    description: italianAddress?.street,
                  }
                : null,

              number: italianAddress?.civicNumber || '',
              exponent: italianAddress?.exponent || '',
              // letter: italianAddress.lettera || '',
              section: italianAddress?.section || '',
              sheet: italianAddress?.sheet || '',
              particle: italianAddress?.particle || '',
              sub: italianAddress?.sub || '',
              cat: italianAddress?.cat || '',
              isHomeless: italianAddress?.isHomeless,
              codTipoVia: italianAddress?.codTipoVia || '',
              addressAuto: italianAddress?.codVia
                ? {
                    code: Number(italianAddress?.codVia),
                    description: italianAddress?.street || '',
                  }
                : undefined,
              descrizioneSpecieToponimo: italianAddress?.codeStreet || '',
              houseOccupationType: italianAddress?.houseOccupationType || '',
              officeContract: italianAddress?.site || '',
              dateContract: italianAddress?.date,
              numberContract: italianAddress?.number?.toString() || '',
              note: italianAddress?.note || '',
            }
          : TypeRegister.RegisterOfficeTemporary === params.tipoRegistro
          ? {
              municipality: MilanMuncipality,
            }
          : undefined,
        foreign: foreignAddress
          ? {
              foreignState: {
                id: foreignAddress?.foreignStateId,
                value: foreignAddress?.foreignState,
                province: foreignAddress?.foreignProvince || '',
              },
              municipality: {
                description: foreignAddress?.foreignMunicipality || '',
                province: foreignAddress?.foreignProvince || '',
                id: foreignAddress?.foreignMunicipalityId || '',
              },
              nationCode: foreignAddress?.foreignStateId || '',
              cap: foreignAddress?.cap || '',
              address: foreignAddress?.toponymDenomination || '',
              civicNumber: foreignAddress?.civic || '',
              consulateCode: foreignAddress?.consulate
                ? { id: foreignAddress?.consulate, value: foreignAddress?.consulate }
                : '',
              territory: foreignAddress?.territory || '',
            }
          : undefined,
      },
    } as PraticeEditResidenceAddress;

    return { ...pratica.data, editAddress: editResidenceInitialValues || {} } as PracticeDetailVM;
  }, [pratica.data, isLoading]);

  // Ristampa dichiarazione
  const reprintDeclarationOfPraticeunavailabilty = useEventCallback(() => {
    (
      printDeclarationUnavailability({
        data: {
          richiestaDichiarazioneDichiaranteVO: {
            codiceEnte: params.codiceEnte || undefined,
            idAnnoPratica: params.idAnnoPratica
              ? Number.parseInt(params.idAnnoPratica, 10)
              : undefined,
            progressivoPratica: params.progressivoPratica
              ? Number.parseInt(params.progressivoPratica, 10)
              : undefined,
            tipoRegistro: params.tipoRegistro || undefined,
            dataRilascioDocumento:
              initialValues?.accountholder?.releaseDocumentDate?.toFormat('yyyy-MM-dd') ||
              initialValues?.applicant?.releaseDocumentDate?.toFormat('yyyy-MM-dd') ||
              undefined,
            luogoRilascioDocumento:
              initialValues?.accountholder?.locationDocument ||
              initialValues?.applicant?.locationDocument ||
              undefined,
            numeroDocumento:
              initialValues?.accountholder?.numberDocument ||
              initialValues?.applicant?.numberDocument ||
              undefined,
          },
        },
        responseType: 'blob',
      }) as ResponsePromise<Blob>
    ).then((response) => {
      const pdfCertificate = response?.data;
      if (pdfCertificate) {
        const blob = new Blob([pdfCertificate], { type: 'application/pdf' });
        blobToBase64(blob).then((base64) => {
          setPdfModal({
            data: base64.split(',')[1],
            name: 'Riepilogo stampa',
            open: true,
          });
        });
      }
    });
  });

  const getAttachmentComunicationProcedureStart = useEventCallback(() => {
    (
      getAttachmentComunicationProcedureStartFunc({
        data: {
          codiceEnte: params.codiceEnte || undefined,
          idAnnoPratica: params.idAnnoPratica
            ? Number.parseInt(params.idAnnoPratica, 10)
            : undefined,
          progressivoPratica: params.progressivoPratica
            ? Number.parseInt(params.progressivoPratica, 10)
            : undefined,
          tipoRegistro: params.tipoRegistro || undefined,
          dataPratica: initialValues?.practice?.dateOpen,
          cognomeNomeResponsabile: initialValues?.managerCode,
          pec: initialValues?.movementType?.pec,
          telefono: initialValues?.movementType?.telephone,
        },
        responseType: 'blob',
      }) as ResponsePromise<Blob>
    ).then((response) => {
      const pdfCertificate = response?.data;
      if (pdfCertificate) {
        const blob = new Blob([pdfCertificate], { type: 'application/pdf' });
        blobToBase64(blob).then((base64) => {
          setPdfModal({
            data: base64.split(',')[1],
            name: 'Riepilogo stampa',
            open: true,
          });
        });
      }
    });
  });

  const printComunicationToPerson = useEventCallback(() => {
    (
      printComunicationToPersonFunc({
        data: {
          codiceEnte: params.codiceEnte || undefined,
          idAnnoPratica: params.idAnnoPratica
            ? Number.parseInt(params.idAnnoPratica, 10)
            : undefined,
          progressivoPratica: params.progressivoPratica
            ? Number.parseInt(params.progressivoPratica, 10)
            : undefined,
          tipoRegistro: params.tipoRegistro || undefined,
          dataPratica: initialValues?.practice?.dateOpen,
        },
        responseType: 'blob',
      }) as ResponsePromise<Blob>
    ).then((response) => {
      const pdfCertificate = response?.data;
      if (pdfCertificate) {
        const blob = new Blob([pdfCertificate], { type: 'application/pdf' });
        blobToBase64(blob).then((base64) => {
          setPdfModal({
            data: base64.split(',')[1],
            name: 'Riepilogo stampa',
            open: true,
          });
        });
      }
    });
  });

  const printComunicationToPersonBO = useEventCallback(() => {
    (
      printComunicationToPersonBOFunc({
        data: {
          codiceEnte: params.codiceEnte || undefined,
          idAnnoPratica: params.idAnnoPratica
            ? Number.parseInt(params.idAnnoPratica, 10)
            : undefined,
          progressivoPratica: params.progressivoPratica
            ? Number.parseInt(params.progressivoPratica, 10)
            : undefined,
          tipoRegistro: params.tipoRegistro || undefined,
          dataPratica: initialValues?.practice?.dateOpen,
        },
        responseType: 'blob',
      }) as ResponsePromise<Blob>
    ).then((response) => {
      const pdfCertificate = response?.data;
      if (pdfCertificate) {
        const blob = new Blob([pdfCertificate], { type: 'application/pdf' });
        blobToBase64(blob).then((base64) => {
          setPdfModal({
            data: base64.split(',')[1],
            name: 'Riepilogo stampa',
            open: true,
          });
        });
      }
    });
  });

  const handleRedirect = useEventCallback(() => {
    const redirectPractice = window.location.search.split('?redirectUri=')[1] || '';
    const redirectHistoryPractice = window.location.search.split('?redirectUriHistory=')[1] || '';
    navigate(redirectPractice || redirectHistoryPractice);
  });

  const viewMessiData: HttpResponse<PracticeData> = useMemo(() => {
    return viewMessi.data as HttpResponse<PracticeData>;
  }, [viewMessi.data]);

  return (
    <Fragment>
      <div className="pmi-d-block pmi-d-md-flex pmi-justify-content-between">
        <Breadcrumbs items={isDetail ? PracticeDetailCrumbs : PracticeManagementCrumbs} />
        {redirectUri || redirectUriHistory ? (
          <div className="pmi-my-2 pmi-w-30 pmi-w-lg-20">
            <PmiButton onClick={handleRedirect} fullWidth variant="outlined" color="cdmBrand">
              Torna indietro
            </PmiButton>
          </div>
        ) : null}
      </div>
      <PmiTitle title={isDetail ? 'Dettaglio pratiche' : 'Gestione pratiche'} />
      {isLoading ? undefined : (
        <Formik initialValues={(initialValues || {}) as PracticeDetailVM} onSubmit={noop}>
          <Form>
            <Grid container spacing={1}>
              <Grid item xs={12} md={3}>
                {isPraticeUnAvailability ? (
                  <ButtonsIsUnAvailability
                    handleExit={handleExit}
                    handleStep={setActive}
                    redirectUriHistory={Boolean(redirectUriHistory)}
                    printVerbalOfPraticeUnavailabilty={printVerbalOfPraticeUnavailabilty}
                    printDeclarationOfPraticeunavailabilty={
                      reprintDeclarationOfPraticeunavailabilty
                    }
                    printAttachmentDeclarationDeclarant={getAttachmentDeclarationFunc}
                    printComunicationProcedureStart={getAttachmentComunicationProcedureStart}
                    printComunicationToPerson={printComunicationToPerson}
                    printComunicationToPersonBO={printComunicationToPersonBO}
                    activeStep={active}
                    isDetail={isDetail}
                    onPrintFolder={onPrintFolder}
                    onPrintReceipt={onPrintReceipt}
                    viewMessi={viewMessiData?.payload?.varie || ''}
                    tipoIniziativa={initialValues?.practice?.tipoIniziativa}
                    typeRegister={params.tipoRegistro}
                  />
                ) : (
                  <Buttons
                    handleExit={handleExit}
                    handleStep={setActive}
                    activeStep={active}
                    hasAttentionNote={hasAttentionNote}
                    redirectUriHistory={Boolean(redirectUriHistory)}
                    isDetail={isDetail}
                    onPrintFolder={
                      params.tipoRegistro === TypeRegister.RegisterOfficeTemporary
                        ? onPrintFolderForPracticeTemporary
                        : onPrintFolder
                    }
                    onPrintReceipt={
                      params.tipoRegistro === TypeRegister.RegisterOfficeTemporary
                        ? onPrintReceiptForPracticeTemporary
                        : onPrintReceipt
                    }
                    onPrintLetter={onPrintLetter}
                    tipoIniziativa={initialValues?.practice?.tipoIniziativa}
                    typeRegister={params.tipoRegistro}
                    typePractice={params.tipoPratica}
                    viewMessi={viewMessiData?.payload?.varie || ''}
                  />
                )}
              </Grid>
              <Grid item xs={12} md={9}>
                {isPraticeUnAvailability ? (
                  <FormDetailIsUnAvailability
                    loadViewMessi={loadViewMessi}
                    loadUpdateDate={loadUpdateDate}
                    redirectUriHistory={Boolean(redirectUriHistory)}
                    step={active}
                    isDetail={isDetail}
                    tipoIniziativa={initialValues?.practice?.tipoIniziativa}
                    noteMesso={viewMessiData?.payload?.noteOperazione}
                    practiceData={initialValues || undefined}
                    datiMesso={viewMessiData?.payload}
                  />
                ) : (
                  <FormDetail
                    loadViewMessi={loadViewMessi}
                    loadUpdateDate={loadUpdateDate}
                    redirectUriHistory={Boolean(redirectUriHistory)}
                    step={active}
                    isDetail={isDetail}
                    tipoIniziativa={initialValues?.practice?.tipoIniziativa}
                    noteMesso={viewMessiData?.payload?.noteOperazione}
                    datiMesso={viewMessiData?.payload}
                  />
                )}
              </Grid>
            </Grid>
          </Form>
        </Formik>
      )}
      {pdfModal.open ? (
        <ModalViewerPDF
          open={pdfModal.open}
          data={pdfModal.data}
          name={pdfModal.name}
          title="Stampa"
          onClose={() => {
            // if (pdfModal.isPracticeUnAvailability) {
            //   setSuccessModal(true);
            // }
            setPdfModal({ data: '', open: false, name: '' });
            if (listSubjectPraticeunavailabilty.allListSubjectArray.length) {
              setListSubjectPraticeunavailabilty({
                allListSubjectArray: [],
                currentListSubject: [],
              });
            }
          }}
          customOtherButton={
            listSubjectPraticeunavailabilty.currentListSubject.length &&
            listSubjectPraticeunavailabilty.allListSubjectArray.length > 1
              ? 'Stampa altro soggetto'
              : ''
          }
          onClickOtherButton={printOtherSubjectPraticeunavailabilty}
        />
      ) : undefined}
      <PrintSuccessModal
        isOpen={isSuccessModalOpen}
        onClose={() => setSuccessModal(false)}
        reprint={printVerbalOfPraticeUnavailabilty}
      />
    </Fragment>
  );
};

PracticeDetailPageComponent.displayName = 'Practice Detail Page component';

const PracticeDetailPage = memo(PracticeDetailPageComponent);

export default PracticeDetailPage;
